import { CheckCircle2, FileText, Clock, ShieldCheck } from "lucide-react";

const ITEMS = [
  {
    icon: CheckCircle2,
    title: "ATP-Verified Clean",
    desc: "Science-backed bacteria testing every visit",
  },
  {
    icon: FileText,
    title: "Documented & Reported",
    desc: "Condition reports after every service",
  },
  {
    icon: Clock,
    title: "Scheduled Operations",
    desc: "Weekly or bi-weekly routes, on your timeline",
  },
  {
    icon: ShieldCheck,
    title: "Liability Aware",
    desc: "Condition logging protects your investment",
  },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="border-b border-[var(--xw-line)] bg-[var(--xw-bg)]"
    >
      <div className="xw-container grid grid-cols-2 md:grid-cols-4">
        {ITEMS.map((it, idx) => (
          <div
            key={it.title}
            data-testid={`trust-item-${idx}`}
            className={`py-8 md:py-10 px-2 md:px-6 ${
              idx !== 0 ? "md:border-l border-[var(--xw-line)]" : ""
            } ${idx >= 2 ? "border-t md:border-t-0 border-[var(--xw-line)]" : ""}`}
          >
            <div className="flex items-start gap-4">
              <div className="shrink-0 mt-0.5">
                <it.icon size={22} strokeWidth={1.5} />
              </div>
              <div>
                <div className="font-display font-bold tracking-tight text-[15px] md:text-base">
                  {it.title}
                </div>
                <div className="text-[13px] md:text-sm text-[var(--xw-muted)] mt-1 leading-snug">
                  {it.desc}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
